import { AppPagePaths } from "App/routes/paths";
import { lazyWithRetries } from "Utils/LazyWithRetries/LazyWithRetries";

import type { RegalRouteObject } from "App/routes/types";

const RegalLivePage = lazyWithRetries("Regal Live", () => import("Pages/regal-live/RegalLivePage"));
const RegalLiveAIPage = lazyWithRetries("Regal Live AI", () => import("Pages/regal-live-ai/RegalLiveAIPage"));

export const regalLiveRoute: RegalRouteObject = {
    path: AppPagePaths.regalLive,
    element: <RegalLivePage />,
};

export const regalLiveAiRoute: RegalRouteObject = {
    path: AppPagePaths.regalLiveAi,
    element: <RegalLiveAIPage />,
};
